import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.hasAttribute('data-unescape-html')) this.#unescapeHtml();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Dynamic sources on richtext settings use metafield_tag, which escapes HTML
   * stored in multi-line text metafields. If the rendered content is HTML source
   * as text, parse it so lists and markup display as HTML.
   */
  #unescapeHtml() {
    if (this.querySelector('ul, ol, table, div, h1, h2, h3, h4, h5, h6')) return;

    const markup = this.textContent?.trim() ?? '';
    if (!/^<[a-zA-Z!]/.test(markup) || !markup.includes('</')) return;

    this.innerHTML = markup;
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
